// style

import '@ant-design/v5-patch-for-react-19';

import './init';
import React from 'react';
import 'react-circular-progressbar/dist/styles.css';
import 'react-datepicker/dist/react-datepicker.css';
import { createRoot } from 'react-dom/client';
import App from './App';
import './assets/sass/app/app.scss';

const root = createRoot(document.getElementById('root'));
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
